import { render, staticRenderFns } from "./FamilyMember.vue?vue&type=template&id=dbf7bace"
import script from "./FamilyMember.vue?vue&type=script&lang=js"
export * from "./FamilyMember.vue?vue&type=script&lang=js"
import style0 from "./FamilyMember.vue?vue&type=style&index=0&id=dbf7bace&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports